import type { CostFileHeaderValidationResponse } from 'shared/types/roi-hub/fileIngestion.types';
import type { DataAction } from '../../../types/dataAction.type';
import { type CostFileSamplePayload, CostFileTemplateAdapterService } from '../services/CostFileTemplateAdapterService';

export const SET_COST_FILE_SAMPLE = 'SET_COST_FILE_SAMPLE' as const;

export type CostFileSample = {
  uploadedFile?: File;
  parsedCSV?: Record<string, string>[];
  headerValidation?: CostFileHeaderValidationResponse;
};

export const setCostFileSample = ({ uploadedFile, parsedCSV, headerValidation }: CostFileSample) => {
  const costFileTemplateAdapter = new CostFileTemplateAdapterService();
  return {
    type: SET_COST_FILE_SAMPLE,
    data: costFileTemplateAdapter.fileToSample(uploadedFile, parsedCSV, headerValidation),
  };
};

export type SetCostFileSampleAction = DataAction<typeof SET_COST_FILE_SAMPLE, CostFileSamplePayload>;
